import { NegotiationStatusCode } from "@/gql/graphql";
import { NegotiationStatusItem } from "@/features/statistics/components/NegStatusChipMultiSelect";

export const transformSelectedStatusesToNegotiationStatusCodes = (
  selectedNegotiationStatuses: NegotiationStatusItem[]
): NegotiationStatusCode[] =>
  selectedNegotiationStatuses.map(
    (status) => status.value
  ) as NegotiationStatusCode[];

export const getNegotiationStatusCodes = (
  negotiationStatusItems: NegotiationStatusItem[]
) => {
  const transformedNegotiationStatuses =
    transformSelectedStatusesToNegotiationStatusCodes(negotiationStatusItems);
  return transformedNegotiationStatuses.length === 0
    ? Object.values(NegotiationStatusCode)
    : transformedNegotiationStatuses;
};
